import React from "react";
import FridgePageTemplate from "./FridgePageTemplate";

const relatedLinks = [
  { to: "/fridge-service-bangalore", label: "Refrigerator Service" },
  { to: "/single-door-fridge-service-bangalore", label: "Single Door Service" },
  { to: "/side-by-side-fridge-service-bangalore", label: "Side-by-Side Service" },
  { to: "/mini-fridge-service-bangalore", label: "Mini Fridge Service" },
  { to: "/fridge-compressor-repair", label: "Compressor Repair" },
];

const DoubleDoorRefrigeratorService = () => {
  return (
    <FridgePageTemplate
      title="Double Door Refrigerator Service in Bangalore"
      description="Expert double door refrigerator service in Bangalore for cooling, ice maker, and compartment repair with reliable doorstep support."
      keywords="double door refrigerator service bangalore, double door fridge repair bangalore, refrigerator service"
      path="/double-door-refrigerator-service-bangalore"
      bannerTitle="Double Door Refrigerator Service"
      intro={
        <>
          Our team provides professional <span style={{ fontWeight: "bold" }}>double door refrigerator service</span> in Bangalore for cooling issues, freezer problems, and door compartment faults.
        </>
      }
      highlights={[
        "Dual compartment cooling diagnostics",
        "Freezer and fridge repair",
        "Ice maker and water dispenser support",
        "Door seal and hinge repairs",
      ]}
      issues={[
        "Fridge cools but freezer does not",
        "Ice maker or dispenser issues",
        "Strange noises from compressor",
        "Cooling imbalance between compartments",
      ]}
      relatedLinks={relatedLinks}
    />
  );
};

export default DoubleDoorRefrigeratorService;

